import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'
import constants from '@/configuration/constants'

const checkUserHasClusters = (application) => {
  return clientHTTP.get(
    getLinkHref(application, 'clusters'),
    { page: 1, pageSize: 1, fields: 'id' },
    {},
    { defaultErrorMessage: false }
  )
}

const getAllClusters = (application) => {
  return clientHTTP.getAll(getLinkHref(application, 'clusters'), { sort: '+name' })
}

const getClusters = (application, params) => {
  return clientHTTP.get(getLinkHref(application, 'clusters'), params)
}

const getAllEndDevices = (application, params) => {
  return clientHTTP.getAll(getLinkHref(application, 'endDevices'), params)
}

const getEndDevices = (application, params) => {
  return clientHTTP.get(getLinkHref(application, 'endDevices'), params)
}

const createEndDevicesExport = (application, querySearch) => {
  return clientHTTP.post(getLinkHref(application, 'createEndDevicesExport') + (querySearch ? `?search=${querySearch}` : ''))
}

const getEndDevicesExportStatus = (proccessingUrl) => {
  return clientHTTP.get(constants.gmsUrl + proccessingUrl)
}

const createCluster = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'clusters'), params)
}

const getCluster = (endDevice) => {
  return clientHTTP.get(getLinkHref(endDevice, 'cluster'))
}

const updateCluster = (cluster, params = {}) => {
  return clientHTTP.patch(getLinkHref(cluster, 'self'), params)
}

const deleteCluster = (cluster) => {
  return clientHTTP.delete(getLinkHref(cluster, 'self'))
}

const getPushConfigurations = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'pushConfigurations'), params)
}

const getAllPushConfigurations = (application) => {
  return clientHTTP.getAll(getLinkHref(application, 'pushConfigurations'), { sort: '+name' })
}

const createPushConfiguration = (application, params = {}, options = {}) => {
  return clientHTTP.post(getLinkHref(application, 'pushConfigurations'), params, options)
}

const getPushConfigurationHealth = (configuration) => {
  return clientHTTP.get(getLinkHref(configuration, 'pushConfigurationHealth'))
}

const patchPushConfiguration = (configuration, params = {}, options = {}) => {
  return clientHTTP.post(getLinkHref(configuration, 'self'), params, options)
}

const deletePushConfiguration = (configuration) => {
  return clientHTTP.delete(getLinkHref(configuration, 'self'))
}

export default {
  checkUserHasClusters,
  getAllClusters,
  getClusters,
  getAllEndDevices,
  getEndDevices,
  createEndDevicesExport,
  getEndDevicesExportStatus,
  createCluster,
  getCluster,
  updateCluster,
  deleteCluster,
  getPushConfigurations,
  getAllPushConfigurations,
  createPushConfiguration,
  getPushConfigurationHealth,
  patchPushConfiguration,
  deletePushConfiguration
}
